<template>
	<div class="hello" id="detailDom">
		<RobotSocket ref="robotSocket" :nowTime='nowTime' @backSockertData='doSocker($event)' />
		<Head type='admin' @tapStatus="changeTap($event)" @out='headOut($event)'></Head>
		<audio :src="phoneMp3" loop ref="pnhoneAudio"></audio>

		<audio :src="didiMp3" @ended="changeMusic()" ref="eventAudio"></audio>
		<div class="header-box box-top" v-if="attack"></div>
		<div class="header-box box-left" v-if="attack"></div>
		<div class="header-box box-right" v-if="attack"></div>
		<div class="header-box box-bottom" v-if="attack"></div>

		<!-- 一键回充 --> 
		<el-dialog append-to-body :visible.sync="ifRecharge" width="35%" center :close-on-click-modal="false" custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">回充确认</div>
			</div>
			<div class="textarea" id="RechargeDom">
				<el-radio v-model="rechargeValue" label="0">不结束任务（任务时间内达到巡检电量，机器人再次自动执行任务）</el-radio><br>
				<el-radio v-model="rechargeValue" label="1">结束最近巡检任务 {{ nextTaskTime ? "（" + nextTaskTime + "）": ""}}</el-radio><br>
				<el-radio v-model="rechargeValue" label="2">结束当天巡检任务</el-radio>
			</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 25%;" @click="ifRecharge = false">{{ languageJson.Cancel }}</div>
				<div class="newBtn1 newBtn1do" style="width: 25%;" @click="CharingTask()">{{ languageJson.Submit }}</div>
			</div>
		</el-dialog>


		<!-- 事件误识别 -->
		<el-dialog append-to-body :visible.sync="ifWrong" width="30%" center :close-on-click-modal="false" custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.MisidentificationReporting }}</div>
			</div>
			<div class="textarea">
				<div style="margin-bottom: .5vw;">{{ languageJson.BrieflyDescribe }}</div>
				<el-input type="textarea" :rows="3" :placeholder="languageJson.PleaseFillIn" maxlength="200" show-word-limit v-model="remark"></el-input>
			</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 25%;" @click="ifWrong = false">{{ languageJson.Cancel }}</div>
				<div class="newBtn1 newBtn1do" style="width: 25%;" @click="submitWrong()">{{ languageJson.Submit }}</div>
			</div>
		</el-dialog>

		<!-- 丰台语音退出 -->
		<el-dialog append-to-body :visible.sync="ifPTypeDialog" :width="languageCheck == 'English' ? '40%' : '30%'" center :close-on-click-modal="false" custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">
				{{ languageJson.policeSituation }}
			</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 25%;" @click="closeWarning(1)">{{ languageJson.Cancel }}</div>
				<div class="newBtn1 newBtn1do" style="width: 25%;" @click="closeWarning('0')">{{ languageJson.waitingInPlace }}</div>
				<div class="newBtn1 newBtn1do" style="width: 25%;" @click="closeWarning('3')">{{ languageJson.guidedAlarm }}</div>
				<div class="newBtn1 newBtn1do" style="width: 25%;" @click="closeWarning(4)">{{ languageJson.hangUpDirectly }}</div>
			</div>
		</el-dialog>

		<!-- 丰台警情呼叫提醒 -->
		<el-dialog append-to-body :visible.sync="ifWarning" width="30%" center :close-on-click-modal="false" custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">
				【{{ warningObj.robotName }}】{{ languageJson.policeCheck }}</div>
			<div class="btnDom">
				<div class="newBtn1 newBtn1do" style="width: 50%;" @click="toWarning()">{{ languageJson.checkNow }}</div>
			</div>
		</el-dialog>

		<!-- 丰台超过10分钟提醒 -->
		<el-dialog append-to-body :visible.sync="ifWarningEnd" :width="languageCheck == 'English' ? '30%' : '30%'" center :close-on-click-modal="false" custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">【{{ robotInfo.robotName }}】{{ languageJson.continueWaiting }}</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 40%;" @click="endWarning('0')">{{ languageJson.endWaiting }}（{{ ifWarningEndNumber }}）</div>
				<div class="newBtn1 newBtn1do" style="width: 40%;" @click="endWarning('1')">{{ languageJson.continueToWait }}</div>
			</div>
		</el-dialog>

		<!-- 丰台引导报警 -->
		<el-dialog append-to-body :visible.sync="ifWarningClear" width="30%" center :close-on-click-modal="false" custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">{{ languageJson.robotWaitPlace }}</div>
			<div class="btnDom">
				<div class="newBtn1" @click="ifWarningClear=false">{{ languageJson.Cancel }}</div>
				<div class="newBtn1 newBtn1do" @click="handleWarning('3')">{{ languageJson.guidedAlarm }}</div>
				<div class="newBtn1 newBtn1do" @click="handleWarning('2')">{{ languageJson.endWaiting }}</div>
			</div>
		</el-dialog>

		<!-- 最小化紧要事件弹出 -->
		<div class="importantEvent" v-if="openAry.length > 0" @click="openDialog()">
			<div style="display: flex;align-items: center;">
				<img style="width: 0.6vw;margin-right: 0.2vw;" src="../../../../static/imgV2/breathe.gif" alt="">
				<div>{{ languageJson.ImportantHandled }}（{{ openAry.length }}）</div>
			</div>
			<img style="width: 1vw;height: 1vw;" src="../../../../static/imgV2/newDialog-2.png" alt="">
		</div>

		<div v-if="eventDialog" style="position: fixed;width: 100%;height: 100%;background-color: rgba(0,0,0,0.8);z-index: 999;top:0;left:0;"></div>
		<div :class="eventDialog ? 'openEvent' : 'openEvent closeAEvent'">
			<div style="width: 79%;" ref="openDom">
				<EventFaceOpen v-if="openState == 'face'" @wrong="wrongFun('3', true)" :type='role' :robotInfo="faceInfoOpen" :robotID='robotId' @closeEventFace='closeOpenEvent()'></EventFaceOpen>
				<EventImgOpen v-if="openState == 'imgs'" @wrong="wrongFun('4', true)" :type='role' :robotInfo="robotInfoEventOpen" :robotID='robotId' @closeEventImage='closeOpenEvent()'></EventImgOpen>
			</div>
			<div style="width: 20%;">
				<div style="text-align: right;height: 3vw;">
					<div class="hud-close-btn" @click="eventDialog = false">&times;</div>
				</div>
				<div class="openEventDom" ref="scrollContainer">
					<div v-for="(obj, index) in openAry" :key="index" class="eventListDom" @click="drawOpenEvent(obj, index)">
						 <div class="eventTitle">
							<div class="eventTitle-background"></div>
							<div class="eventTitleName">
								<span>{{ obj.eName }}</span>
								<span>{{ obj.date }} {{ obj.insDate }}</span>
							</div>
						 </div>
						<div class="bottomTitle" v-if="obj.positonName">
							<div class="eventTitles-background"></div>
							<div class="bottomTitleName">
							<el-tooltip 
								effect="dark" 
								:content="obj.positonName || '-'" 
								placement="top"
								:disabled="!obj.positonName || obj.positonName.length <= 13">
								<div class="text-ellipsis">
								{{ obj.positonName.length + obj.positonName ? (obj.positonName.length > 15 ? obj.positonName.substring(0, 15) + '...' : obj.positonName) : '-' }}
								</div>
							</el-tooltip>
							</div>
						</div>	
						<img :src="obj.imgUrl" :class="checkImg == index ? 'checkImgDomColor' : 'checkImgDom'" alt="">
					</div>
				</div>
			</div>
		</div>

		<div class="returnBtn" style="width: 98%;margin: 4px auto;height: 20px;text-align: left;position: relative;">
			<img v-if="languageCheck == 'English'" src="../../../../static/imgV2/backButtonEn.png" alt="" style="width: 4vw;cursor: pointer;z-index: 99;" @click="backLink()">
			<img v-else src="../../../../static/imgV2/backButton.png" alt="" style="width: 4vw;cursor: pointer;z-index: 99;" @click="backLink()">
		</div>

		<!-- 退出登陆提醒 -->
		<el-dialog append-to-body :visible.sync="dialogVisible" width="30%" center custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">{{ languageJson.ExitText }}</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 40%;" @click="dialogVisible = false">{{ languageJson.Cancel }}</div>
				<div class="newBtn1 newBtn1do" style="width: 40%;" @click="getOut()">{{ languageJson.Exit }}</div>
			</div>
		</el-dialog>

		<!-- 一件处理 -->
		<el-dialog append-to-body :visible.sync="ifShowHandle" width="30%" center custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">{{ languageJson.unhandledEvents }}</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 40%;" @click='ifShowHandle = false'>{{ languageJson.Cancel }}</div>
				<div class="newBtn1 newBtn1do" style="width: 40%;" @click='oneHandle()'>{{ languageJson.confirmProcessing }}</div>
			</div>
		</el-dialog>

		<!-- 接听语音 -->
		<el-dialog append-to-body :visible.sync="ifVoice" width="30%" center :close-on-click-modal="false" custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">【{{ ifVoiceObj.robotName }}】{{ languageJson.Emergency }}</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 40%;" @click='closeVoice()'>{{ languageJson.hangup }}</div>
				<div class="newBtn1 newBtn1do" style="width: 40%;" @click='openVoice()'>{{ languageJson.answer }}</div>
			</div>
		</el-dialog>

		<!-- 接听其他机器 -->
		<el-dialog append-to-body :visible.sync="ifAgainVoiceThen" width="30%" center custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">{{ languageJson.EmergencyClosed }}</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 40%;" @click='ifAgainVoiceThen = false'>{{ languageJson.hangup }}</div>
				<div class="newBtn1 newBtn1do" style="width: 40%;" @click='openVoiceThen()'>{{ languageJson.answer }}</div>
			</div>
		</el-dialog>

		<!-- 地图放大展示 -->
		<el-dialog append-to-body :visible.sync="ifMap" center class="img-user" custom-class="transparent-dialog">
			<div v-if="robotInfo.robotType != '04' && robotInfo.robotType != '05' && robotInfo.robotType != '06' && robotInfo.robotType != '07'">
				<RobotMap @closeRobot="ifMap = false" :position='robotInfo' :posInfo='posInfo' />
			</div>
			<div v-else>
				<RobotMapInfo @closeRobot="ifMap = false" :position='robotInfo' :posInfo='posInfo' />
			</div>
		</el-dialog>

		<!-- 视频全屏 -->
		<el-dialog append-to-body :visible.sync="flvOpen" width="100%" center custom-class="transparent-dialog">
			<div style="position: fixed;width: 100%;height: 100%;left: 0%;top: 0%;background-color: black;">
				<i class="el-icon-close" style="position: absolute;right: 10px;top: 10px;cursor: pointer;font-size: 2vw;z-index: 99;color: white;" @click="flvOpen = false"></i>
				<RobotFlv :private="isPrivate" :isStart="isStart" :playStatus='true' :ststus='checkFlv.ststus' :rid='checkFlv.robotId' :rtmpSrc="checkInfo.src" />
			</div>
		</el-dialog>

		<!-- 机器人事件提醒 -->
		<el-dialog append-to-body :visible.sync="ifShowRobot" width="50%" center :close-on-click-modal="false" custom-class="transparent-dialog">
			<div style="width: 100%;height: 100%;position: relative;">
				<EventImgUser @wrong="wrongFun('1', true)" @frontClose="ifShowLeave = true" :type='role' :robotInfo="robotInfoEvent" @closeEventImage='ifShowRobot = false'></EventImgUser>
			</div>
		</el-dialog>

		<!-- 机器人人脸提醒 -->
		<el-dialog append-to-body :visible.sync="ifShowFace" width="50%" center :close-on-click-modal="false" custom-class="transparent-dialog">
			<div style="width: 100%;height: 100%;position: relative;">
				<EventFaceUser @wrong="wrongFun('2', true)" @frontClose="ifShowLeave = true" :type='role' @closeEventFace='ifShowFace = false' :robotInfo="faceInfo"></EventFaceUser>
			</div>
		</el-dialog>

		<!-- 重要事件未处理提醒 -->
		<el-dialog append-to-body :visible.sync="ifShowLeave" width="30%" center custom-class="hud-dialog">
			<div class="gifDom">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.OperationTips }}</div>
			</div>
			<div class="title">{{ languageJson.eventLeavefirst }}</div>
			<div class="btnDom">
				<div class="newBtn1" style="width: 40%;" @click='ifShowLeave = false'>{{ languageJson.Cancel }}</div>
				<div class="newBtn1 newBtn1do" style="width: 40%;" @click='ifShowRobot = false;ifShowLeave = false;ifShowFace = false'>{{ languageJson.confirm }}</div>
			</div>
		</el-dialog>

    <MoveBox ref="moveBox1" v-if="ifPoint" :ifTime="ifPoint" @close='ifPoint = false'>
      <div class="eventAddDom" >
        <div class="title-top" style="justify-content: flex-start">
          <img src="../../../../static/imgV2/detail-title.png" alt="">
          <div class="title-top-text">添加点位</div>
        </div>
        <el-form :model="pointObj" ref="pointObj" :label-width=" languageCheck == 'English' ? '5vw' : '5vw' " class="demo-ruleForm" style="width: 95%;paddingTop: 0.1vw;">

          <el-form-item label="点位类型">
            <el-select v-model="pointObj.ptype" placeholder="请选择点位类型">
              <el-option  label="添加打卡点" value="1"></el-option>
              <el-option v-if="robotInfo.robotType == '08'" label="添加路线点" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="事件类型" v-if="pointObj.ptype == '1'">
            <el-select v-model="pointObj.eventType" placeholder="请选择事件类型">
              <el-option v-for="(item, $index) in selectEvents" :key="$index" :label="item.value" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item  label="名称">
            <el-input v-model="pointObj.name"  label="名称"></el-input>
          </el-form-item>
          <el-form-item v-if="((['90b7eb8140f7473883deda56cea708af','838d9eb37ea24cc4b545d238d9c62168','c5759d6cbd4c48718c651b6cdc05f2db','ff9b6d26214245d8a64717947d8abb5e'].includes(tenantId)) && pointObj.eventType) || (['E0351','E0352','E0353','E0354','E0355','E0356','E0357','E0023','E0361','E0362','E0363','E0364','E0365','E0366','E0367','E0368','E0369','E0370','E0371','E0373','E0375','E0376','E0379','E0380','E0382','E0383','E0385','E0386'].includes(pointObj.eventType))"  
		    label="阈值"> 
            <el-input v-model="pointObj.threshold"  label="阈值"></el-input>
          </el-form-item>
          <el-form-item v-if="((tenantId=='90b7eb8140f7473883deda56cea708af' || tenantId=='c5759d6cbd4c48718c651b6cdc05f2db' || tenantId=='ff9b6d26214245d8a64717947d8abb5e') && pointObj.eventType) || (['E0351','E0352', 'E0353','E0354','E0355','E0356', 'E0357', 'E0023', 'E0361','E0362', 'E0363', 'E0364', 'E0365','E0366', 'E0367', 'E0368','E0369','E0370', 'E0371', 'E0373', 'E0375','E0376', 'E0379','E0380', 'E0382','E0383', 'E0385', 'E0386'].includes(pointObj.eventType))"  label="仪表单位">
            <el-input v-model="pointObj.unit"  label="仪表单位"></el-input>
          </el-form-item>

          <el-form-item v-if="pointObj.eventType=='E0013' && pointObj.ptype == '1'" label="灭火器数量">
            <el-input-number v-model="pointObj.fireExtinguisherNum"  :min="1" :max="10" label="灭火器数量"></el-input-number>
          </el-form-item>

          <el-form-item label="上传类型" v-if="pointObj.eventType=='E0001' && pointObj.ptype == '1'">
            <el-select v-model="pointObj.fileType" placeholder="请选择上传类型">
              <el-option  label="图片" value="0"></el-option>
              <el-option  label="视频" value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="录制方式" v-if="pointObj.eventType=='E0001' && pointObj.ptype == '1' && pointObj.fileType == '1' ">
            <el-select v-model="pointObj.videoType" placeholder="请选择录制方式">
              <el-option  label="定点录制" value="0"></el-option>
              <el-option  label="360°巡游" value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="视频长度(秒)" v-if="pointObj.eventType=='E0001' && pointObj.ptype == '1' && pointObj.fileType == '1' && pointObj.videoType == '0' ">
            <el-input-number v-model="pointObj.videoTime"  :min="1" :max="60" label="视频长度"></el-input-number>
          </el-form-item>

          <el-form-item :label="languageJson.Notes" > 
            <el-input type="textarea" maxlength="200" rows="6" v-model="pointObj.remark" :placeholder="languageJson.pleaseEnterContent"></el-input>
          </el-form-item>
        </el-form>
        <div style="width: 95%;text-align: right;color: gray;margin-top: -5px;">
          {{pointObj.remark.length}}/200
        </div>
        <div style="display: flex;width: 100%;align-items: center;justify-content: center;padding-bottom: 1vw;">
          <div class="btn1" @click='pointOff()'>{{ languageJson.Cancel }}</div>
          <div class="btn1 btnDo" @click='addPoint()'>{{ languageJson.confirm}}</div>
        </div>
      </div>
    </MoveBox>

		<MoveBox ref="moveBox1" v-if="ifEvent" :ifTime="ifEvent" @close='ifEvent = false'>
			<div class="eventAddDom" >
				<div class="title-top" style="justify-content: flex-start">
					<img src="../../../../static/imgV2/detail-title.png" alt="">
					<div class="title-top-text">{{ languageJson.createNewEvent }}</div>
				</div>
				<el-form :model="ruleForm" ref="ruleForm" :label-width=" languageCheck == 'English' ? '5vw' : '4vw' " class="demo-ruleForm" style="width: 95%;paddingTop: 0.5vw;">
					<el-form-item :label="languageJson.eventType">
						<el-select v-model="ruleForm.eType" :placeholder="languageJson.selectEventType">
							<el-option v-for="(obj, $index) in typeList" :key="$index" :label="obj.value" :value="obj.code"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="languageJson.Notes" >
						<el-input type="textarea" maxlength="200" rows="6" v-model="ruleForm.position" :placeholder="languageJson.pleaseEnterContent"></el-input>
					</el-form-item>
				</el-form>
				<div style="width: 95%;text-align: right;color: gray;margin-top: -5px;">
					{{ruleForm.position.length}}/200
				</div>
				<div style="display: flex;width: 100%;align-items: center;justify-content: center;padding-bottom: 1vw;">
					<div class="btn1" @click='eventOff()'>{{ languageJson.Cancel }}</div>
					<div class="btn1 btnDo" @click='addEvent()'>{{ languageJson.confirm }}</div>
				</div>
			</div>
		</MoveBox>

		<MoveBox ref="moveBox1" v-if="ifControl" :ifTime="ifControl" @close='ifControl = false'>
			<Control v-if="ifControl" @clear='ifControl = false' @changeRadio='changeRadioValue($event)' @sliderValue='sliderValue = 2' :robotInfo='robotInfo' :timeEnd='timeEnd' :ifControl='ifControl' :controlStatus='controlStatus' @controlType='controlStatus = false' :nowTime='nowTime' :timeVo='timeVo'></Control>
		</MoveBox>

		<MoveBox ref="moveBox1" v-if="ifCamera" :ifTime="ifCamera" @close='ifCamera = false'>
			<CameraFlv v-if="ifCamera" @clear='ifCamera = false' @sliderValue='sliderValue = 2' :robotInfo='robotInfo' :timeEnd='timeEnd' :ifRod='ifRod'></CameraFlv>
		</MoveBox>

    <MoveBox ref="moveBox1" v-if="ifRod" :ifTime="ifRod" @close='ifRod = false'>
      <LiftRod v-if="ifRod" @clear='ifRod = false' @sliderValue='sliderValue = 2' :robotInfo='robotInfo' :timeEnd='timeEnd' :ifRod='ifRod'></LiftRod>
    </MoveBox>

		<MoveBox ref="moveBox1" v-if="ifHotFlv" :ifTime="ifHotFlv" @close='ifHotFlv = false'>
			<div style="position: relative;width: 15vw;height: 10vw;background-color: #031746;border: 4px solid black;z-index: 999;">
				<div style="position: absolute;left: 0;top: 0;width: 100%;height: 2vw;z-index: 9999;">
					<div style="position: absolute;background-color: black;opacity: 0.4;width: 100%;height: 100%;"></div>
					<div style="position: absolute;width: 94%;left: 3%;height: 100%;display: flex;align-items: center;justify-content: space-between;color: white;font-size: 0.8vw;">
						<span>{{ languageJson.ThermalImaging }}</span>
						<img style="width: 1vw;height: 1vw;cursor: pointer;" src="../../../../static/imgV2/hotClose.png" @click="ifHotFlv = false" alt="">
					</div>
				</div>
				<RobotFlv :private="isPrivate" :isStart="isStart"  playAudo="play" :playStatus='true' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='robotInfo.flvTherm' />
			</div>
		</MoveBox>

    <MoveBox ref="moveBox1" v-if="ifHotLightFlv" :ifTime="ifHotLightFlv" @close='ifHotLightFlv = false'>
      <div style="position: relative;width: 15vw;height: 10vw;background-color: #031746;border: 4px solid black;z-index: 999;">
        <div style="position: absolute;left: 0;top: 0;width: 100%;height: 2vw;z-index: 9999;">
          <div style="position: absolute;background-color: black;opacity: 0.4;width: 100%;height: 100%;"></div>
          <div style="position: absolute;width: 94%;left: 3%;height: 100%;display: flex;align-items: center;justify-content: space-between;color: white;font-size: 0.8vw;">
            <span>{{ languageJson.ThermalImagingLight }}</span>
            <img style="width: 1vw;height: 1vw;cursor: pointer;" src="../../../../static/imgV2/hotClose.png" @click="ifHotLightFlv = false" alt="">
          </div>
        </div>
        <RobotFlv :private="isPrivate" :isStart="isStart"  playAudo="play" :playStatus='true' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='robotInfo.flvThermLight' />
      </div>
    </MoveBox>

    <MoveBox ref="moveBox1" v-if="ifIndicatorLight" :ifTime="ifIndicatorLight" @close='ifIndicatorLight = false'>
      <div class="eventAddDom">
        <div class="title-top" style="justify-content: flex-start">
          <img src="../../../../static/imgV2/detail-title.png" alt="">
          <div class="title-top-text">指示灯控制</div>
        </div>
        <div style="display: flex; width: 100%; align-items: center; justify-content: center; padding: 1.5vw 0; gap: 1vw;">
          <div class="btn1 btnDo" @click="handleIndicatorLight(0)">开闸</div>
          <div class="btn1 btnDo" @click="handleIndicatorLight(1)">合闸</div>
          <div class="btn1" @click="handleIndicatorLight(2)">停止当前任务</div>
        </div>
      </div>
    </MoveBox>


		<div class="indeBody">
			<div class="left-box">
				<div :style="{backgroundImage: 'url(' + topSmall + ')'}" class="indeBody-left-item">
					<Topleft :vSocketData='vSocketVos' :robotInfo='robotInfo' @changeRobot='changeRobot($event)'></Topleft>
				</div>
				<div :style="{backgroundImage: 'url(' + topSmall + ')'}" class="indeBody-left-item top">
					<BottomLeft v-if="robotInfo.robotId" :mapInfo='mapInfo' :robotInfo='robotInfo' :posInfo ='posInfo' @openMap='showMap()'></BottomLeft>
				</div>
			</div>
			<div class="indeBody-left">
				<div
					style="width: 100%;height: 100%;display: flex;flex-direction: column;justify-content: space-between;">
					<div class="leftTopUl" ref='centerRightRef'>

						<img src="../../../../static/imgV2/robot-x2.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 9;" alt="">
						<div style="position: absolute;width: 100%;height: calc(100% - 2px);top: 1px;left: 0px;">
							<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="checkInfo.src" playAudo="play" @playStop="playStop($event, '1')" :playStatus='playStatus' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='checkInfo.src' />
						</div>
						<div style="position: absolute;top: 25%;left: 10px;z-index: 9;" v-if="(checkInfo.name == languageJson.PanTiltCamera || checkInfo.name == languageJson.FrontCamera) && playStatus">
							<div style="margin: 0 0 10px 5px;font-size: 0.7vw;color: white;">✕ {{Number(sliderValue).toFixed(1)}}</div>
							<el-slider v-model="sliderValue" :max="(robotInfo.robotType == '04' || robotInfo.robotType == '05' || robotInfo.robotType == '06' || robotInfo.robotType == '07') ? 10 : 100" :min="1" :step="1" vertical height="200px">
							</el-slider>
						</div>

						<div v-if="role == 'admin'" class="right-user right-admin">
							<img v-if="robotInfo.robotType != '04' && robotInfo.robotType != '05' && robotInfo.robotType != '06' && robotInfo.robotType != '07'" :src="controlButton.wiper" @mouseenter="controlButton.wiper = controlButton.wiperCheck" @mouseleave="controlButton.wiper = controlButton.wiperConst" alt="" @click="ptzWiper()">
							<img :src="controlButton.voice" @mouseenter="controlButton.voice = controlButton.voiceCheck" @mouseleave="controlButton.voice = controlButton.voiceConst" alt="" @click="callPhone()">
						</div>
						<div v-else class="right-user">
							<img v-if="robotInfo.robotType != '04' && robotInfo.robotType != '05' && robotInfo.robotType != '06' && robotInfo.robotType != '07'" :src="controlButton.wiper" @mouseenter="controlButton.wiper = controlButton.wiperCheck" @mouseleave="controlButton.wiper = controlButton.wiperConst" alt="" @click="ptzWiper()">
							<img :src="controlButton.event" @mouseenter="controlButton.event = controlButton.eventCheck" @mouseleave="controlButton.event = controlButton.eventConst" alt="" @click="ifEvent = true">
							<img :src="controlButton.voice" @mouseenter="controlButton.voice = controlButton.voiceCheck" @mouseleave="controlButton.voice = controlButton.voiceConst" alt="" @click="callPhone()">
							<img :src="controlButton.control" @mouseenter="controlButton.control = controlButton.controlCheck" @mouseleave="controlButton.control = controlButton.controlConst" @click="ifControl = true" alt="">
							<img :src="controlButton.flv" @mouseenter="controlButton.flv = controlButton.flvCheck" @mouseleave="controlButton.flv = controlButton.flvConst" @click="ifCamera = true" alt="">
							<div class="newImgs" v-if="['08','09'].includes(robotInfo.robotType)"><img class="newImg"  :src="controlButton.jtBtn" @mouseenter="controlButton.jtBtn = controlButton.jtBtnCheck" @mouseleave="controlButton.jtBtn = controlButton.jtBtnConst" @click="handelStopClick()" alt=""></div>
				            <div class="newImgs"><img class="newImg"  :src="controlButton.rod" @mouseenter="controlButton.rod = controlButton.rodCheck" @mouseleave="controlButton.rod = controlButton.rodConst" @click="ifRod = true" alt=""></div>
              <!--一键回充-->
              <!--							<img v-if="robotInfo.robotType == '05'" :src="controlButton.recharge" @mouseenter="controlButton.recharge = controlButton.rechargeCheck" @mouseleave="controlButton.recharge = controlButton.rechargeConst" @click="ifRecharge = true" alt="">-->

              <img v-if="robotInfo.robotType == '06'" :src="ifHotFlv ?  controlButton.rcxCheck : controlButton.rcx" @mouseenter="controlButton.rcx = controlButton.rcxCheck" @mouseleave="controlButton.rcx = controlButton.rcxConst" @click="openHotFlv()" alt="">
              <img v-if="robotInfo.robotType == '06'" :src="ifHotLightFlv ? controlButton.kjgCheck : controlButton.kjg" @mouseenter="controlButton.kjg = controlButton.kjgCheck" @mouseleave="controlButton.kjg = controlButton.kjgConst" @click="openHotLightFlv()" alt="">
              <img  v-if="robotInfo.robotType == '08' || robotInfo.robotType == '05' || robotInfo.robotType == '04'" :src="controlButton.point" @mouseenter="controlButton.point = controlButton.pointCheck" @mouseleave="controlButton.point = controlButton.pointConst" alt="" @click="openPoint">
              <div class="waring" v-if="warningDate">
								<span class="time"></span>
								<div>{{ warningDate }}</div>
								<img :src="controlButton.warning" @mouseenter="controlButton.warning = controlButton.warningCheck" @mouseleave="controlButton.warning = controlButton.warningConst" alt="" @click="ifWarningClear = true" alt="">
							</div>
						</div>

						<img style="position: absolute;left: 2.5vw;width: 1.8vw;height: 1.8vw;cursor: pointer;z-index: 9;bottom: 10px;" src="../../../../static/imgV2/Refresh.png" alt="" @click.stop="flvPlay(false, 1)">
<!--						<img v-if="robotInfo.robotType == '06'" style="width: 1.8vw;height: 1.8vw;position: absolute;right: 50px;bottom: 10px;z-index: 99;cursor: pointer;" @click.stop="openHotFlv()" src="../../../../static/imgV2/hotFlv.png" >-->
<!--            <img v-if="robotInfo.robotType == '06'" style="width: 1.8vw;height: 1.8vw;position: absolute;right: 80px;bottom: 10px;z-index: 99;cursor: pointer;" @click.stop="openHotLightFlv()" src="../../../../static/imgV2/hotFlv.png" >-->
            <img style="width: 1.8vw;height: 1.8vw;position: absolute;right: 10px;bottom: 10px;z-index: 99;cursor: pointer;" @click.stop="robotX2(robotInfo)" src="../../../../static/imgV2/fullScreen-0.png" alt="">
						<img style="width: 1.8vw;height: 1.8vw;position: absolute;left: 10px;bottom: 10px;z-index: 99;cursor: pointer;" class="divCenterLi-flvPlay" :src="playStatus ? play0 : play1" alt="" @click="flvPlay(playStatus, 1)">
						<div class="powerDom">
							<div style="margin-top: 0.4vw;width: 1.2vw;">
								<RobotPower class="power-icon" :number='robotInfo.power' :type='robotInfo.ststus' />
							</div>
							<div class="power-text" style="font-size: 0.8vw;margin-top: 0.2vw">&nbsp;{{ robotInfo.power}}%</div>
						</div>
						<div class="powerName">{{ checkInfo.name}}</div>
					</div>
					<div v-if="robotInfo.robotType == '06'" class="bottomFlvDom bottomFlvDom-scroll">
						<!-- 原有3个改为6个小视频区域 -->
						<div class="flvDom33 flvDom6" >
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" style="" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.frontSrc" :initialNO='true' playAudo="stop" @playStop="playStop($event, '2')" :playStatus='playStatus1' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.frontSrc' @closeFlv="setVideoEnd('1')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('frontName', 'frontSrc')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus1 ? play0 : play1" alt="" @click="flvPlay(playStatus1, 2)">
							<div class="flvBottomName">{{ leftInfo.frontName }}</div>
						</div>
						<div class="flvDom33  flvDom6">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.backSrc" :initialNO='true' playAudo="stop" @playStop="playStop($event, '3')" :playStatus='playStatus2' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.backSrc' @closeFlv="setVideoEnd('2')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('backName', 'backSrc')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus2 ? play0 : play1" alt="" @click="flvPlay(playStatus2, 3)">
							<div class="flvBottomName">{{ leftInfo.backName }}</div>
						</div>
						<div class="flvDom33  flvDom6">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.leftSrc" :initialNO='true' playAudo="stop" @playStop="playStop($event, '4')" :playStatus='playStatus3' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.leftSrc' @closeFlv="setVideoEnd('3')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('leftName', 'leftSrc')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus3 ? play0 : play1" alt="" @click="flvPlay(playStatus3, 4)">
							<div class="flvBottomName">{{ leftInfo.leftName }}</div>
						</div>
						<div class="flvDom33  flvDom6">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.rightSrc" :initialNO='true' playAudo="stop" @playStop="playStop($event, '5')" :playStatus='playStatus4' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.rightSrc' @closeFlv="setVideoEnd('4')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('rightName', 'rightSrc')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus4 ? play0 : play1" alt="" @click="flvPlay(playStatus4, 5)">
							<div class="flvBottomName">{{ leftInfo.rightName }}</div>
						</div>
						<div class="flvDom33  flvDom6">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.upSrc" :initialNO='true' playAudo="stop" @playStop="playStop($event, '6')" :playStatus='playStatus5' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.upSrc' @closeFlv="setVideoEnd('5')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('upName', 'upSrc')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus5 ? play0 : play1" alt="" @click="flvPlay(playStatus5, 6)">
							<div class="flvBottomName">{{ leftInfo.upName }}</div>
						</div>
						<div class="flvDom33  flvDom6">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.thermSrc" :initialNO='true' playAudo="stop" @playStop="playStop($event, '7')" :playStatus='playStatus6' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.thermSrc' @closeFlv="setVideoEnd('6')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('thermName', 'thermSrc')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus6 ? play0 : play1" alt="" @click="flvPlay(playStatus6, 7)">
							<div class="flvBottomName">{{ leftInfo.thermName }}</div>
						</div>
					</div>
					<div v-else class="bottomFlvDom">
						<div class="flvDom49">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate"  :isStart="isStart"  v-if="leftInfo.leftSrc" :initialNO='true' playAudo="stop" @playStop="playStop($event, '2')" :playStatus='playStatus1' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.leftSrc' @closeFlv="setVideoEnd('1')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('leftName', 'leftSrc')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus1 ? play0 : play1" alt="" @click="flvPlay(playStatus1, 2)">
							<div class="flvBottomName">{{ leftInfo.leftName}}</div>
						</div>
						<div class="flvDom49">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.rightSrc" :initialNO='true' playAudo="stop" @playStop="playStop($event, '3')" :playStatus='playStatus2' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.rightSrc' @closeFlv="setVideoEnd('2')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('rightName', 'rightSrc')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus2 ? play0 : play1" alt="" @click="flvPlay(playStatus2, 3)">
							<div class="flvBottomName">{{ leftInfo.rightName }}</div>
						</div>
						<div class="flvDom49" v-if="tenantId == '2847ec53457c42a88a87ca7d462e5dde'">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.rightSrcTwo" :initialNO='true' playAudo="stop" @playStop="playStop($event, '5')" :playStatus='playStatus4' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.rightSrcTwo' @closeFlv="setVideoEnd('5')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('rightNameTwo', 'rightSrcTwo')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus4 ? play0 : play1" alt="" @click="flvPlay(playStatus4, 5)">
							<div class="flvBottomName">{{ leftInfo.rightNameTwo}}</div>
						</div>
						<div class="flvDom49" v-if="tenantId == '2847ec53457c42a88a87ca7d462e5dde'">
							<img src="../../../../static/imgV2/robot-x1.png" class="robotX1Icon" alt="">
							<div class="robotFlvDom" >
								<RobotFlv :private="isPrivate" :isStart="isStart"  v-if="leftInfo.rightSrcThree" :initialNO='true' playAudo="stop" @playStop="playStop($event, '6')" :playStatus='playStatus5' :vSocketData='posInfo' :ststus='robotInfo.ststus' :rid='robotInfo.robotId' :rtmpSrc='leftInfo.rightSrcThree' @closeFlv="setVideoEnd('6')" />
							</div>
							<div class="flvRtmpDom" @click.stop="changeRtmp('rightNameThree', 'rightSrcThree')"></div>
							<img class="divCenterLi-flvPlay flvPlayDom" :src="playStatus5 ? play0 : play1" alt="" @click="flvPlay(playStatus5, 6)">
							<div class="flvBottomName">{{ leftInfo.rightNameThree}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="indeBody-right">
				<div :style="{backgroundImage: 'url(' + topSmall + ')'}"  class="indeBody-right-item"  v-if="robotInfo.number == '12345'">
					<div class="title-top" style="justify-content:left;">
					<img src="../../../../static/imgV2/detail-title.png" alt="">
					<div class="title-top-text">巡逻模式</div>
					</div>
					<!-- 台账状态开关 -->
					<div class="ledger-switch-wrapper">
					<span class="ledger-text">台账状态</span>
					<el-switch
						v-model="isLedgerStatus"
						active-color="#00f0ff"
						inactive-color="#004080"
						active-text="开启"
						inactive-text="关闭"
						@change="changeLedgerStatus"
					/>
					</div>
				</div>
				<div :style="{backgroundImage: 'url(' + topSmall + ')'}" class="indeBody-right-item" v-else>
					<TopRight :groupInfo='groupInfo'></TopRight>
				</div>
				<div :style="{backgroundImage: 'url(' + topSmall + ')'}" class="indeBody-right-item hight" >
					<BottomRight v-if="robotInfo.number" :type='role' @oneHandle="showHandle($event)" @ifShowRobot="showRobot($event)" :rightUl='rightUl' :robotNumber='robotInfo.number'></BottomRight>
				</div>
			</div>
		</div>
		<div v-if="ifSIP">
			<SIPAudio @close='closeSip()' :visible.sync="ifSIP" :useVoice='ifVoiceObj.useVoice' :robotId='ifVoiceObj.robotNumber'
				:robotName="ifVoiceObj.robotName" :robotType="robotInfo.robotType" :ifSIP='ifSIP' :role='role' :activePhone='activePhone' style='z-index: 9999;' />
		</div>
	</div>
</template>

<script>
	import RobotSocket from '@/components/RobotSocket.vue'
	import Head from '@/components/Head.vue'
	import Topleft from '../components/topleft.vue'
	import BottomLeft from '../components/bottomLeft.vue'
	import TopRight from '../components/topRight.vue'
	import BottomRight from '../components/bottomRight.vue'
	import EventFaceUser from '../components/eventFaceUser.vue'
	import EventFaceOpen from '../components/eventFaceOpen.vue'
	import EventImgUser from '../components/eventImgUser.vue'
	import EventImgOpen from '../components/eventImgOpen.vue'
	import RobotFlv from '@/components/flv264V3.vue'
	import RobotMap from '@/components/RobotMap.vue'
	import RobotMapInfo from '@/components/RobotMapInfo.vue'
	import RobotPower from '@/components/RobotPower.vue'
	import MoveBox from '@/components/MoveBox.vue'
	import CameraFlv from '../components/cameraFlv.vue'
  import LiftRod from '../components/liftRod.vue'
	import Control from '../components/control.vue'
	import { WebRtc, SIGNAL_IP, SIGNAL_WS } from "../../../utils/WebRtc.js"

	import {
		getRobotEventDetail,
		getRobotEventInfo,
		completionInfo,
		focusesControl,
		getPtz,
		saveRobotHistory,
		ptzWiper,
		getEventType,
		getReportEventTypeByRobotId,
		addEvent,
		control,
		deControl,
		angleControl,
		handleEventBatch,
		personType,
		callCount,
		getRobotEventDetailRobot,
		alarmOperate,
		ftRobotHangUp,
		reportMisIdentification,
		getRobotEventList,
		setCharingTask,
		getGroup,
    eventTypeByRobotId,
    setFloorPositon,
    setPositon,
    setCoord,
    positonInfo,
	sendButtonStop,
	} from '@/api/admin.js'
	import {
		getItem,
		setToken,
		setItem,
		removeItem,
		removeToken
	} from '@/utils/auth'
	import {
		robotDetail,
		getM3u8Video,
		getXM3u8Video,
		mapRoute,
		currentDuty,
		getLedgerStatus,
		switchLedger,
		sendIndicatorLight
	} from '@/api/indexV2'
	import {
		groupByDuty,
		controlCommand,
		initialize
	} from '@/api/user.js'
	export default {
		name: 'detail',
		components: {
			Head,
			Topleft,
			BottomLeft,
			TopRight,
			BottomRight,
			RobotSocket,
			EventFaceUser,
			EventFaceOpen,
			EventImgUser,
			EventImgOpen,
			RobotFlv,
			RobotMap,
			RobotMapInfo,
			RobotPower,
			MoveBox,
			CameraFlv,
			Control,
      LiftRod
		},
		data() {
			return {
			  videoData:{}, 
			  isPrivate:false,//是否私有化部署 
			  isStart:false, // 只有为true的时候 才能调用webRtc的接口
			  selectEvents:[],
			  pointObj :{
			    ptype:"",
          eventType:"",
          name:"",
          remark:"",
          fileType:"",
          videoType:"",
          videoTime:10,
          fireExtinguisherNum:2,
          threshold: "",
          unit: "",
        },
				groupList: [],
				evenType: '0',
				ifWrong: false,
				remark: '',
				activePhone: false,
				rechargeValue: '0',
				warningObj: {
					robotId: "",
					robotName: "",
					robotNumber: ""
				},
				ifRecharge: false,
				ifWarningInterva: null,
				warningClose: false,
				ifWarning: false,
				ifWarningEndNumber: 10,
				ifWarningEndInterval: null,
				ifWarningEnd: false,
				ifWarningClear: false,
				warningDate: 0,
				warningBlou: false,
				warningInterval: null,
				checkImg: 0,
				ifHotFlv: false,
        ifHotLightFlv: false,
				openAry: [],
				openState: '',
				faceInfoOpen: {},
				robotInfoEventOpen: {},
				eventDialog: false,
				openEventHeight: 0,
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
        who: localStorage.getItem('userInfo'),
				vSocketVos: {},
				phoneMp3: require('../../../../static/audio/phone.mp3'),
				didiMp3: require('../../../../static/audio/didi.mp3'),
				topSmall: require('../../../../static/imgV2/small-bg.png'),
				wbrtcBg: require('../../../../static/imgV2/wbrtc-bg.png'),
				timeBg: require('../../../../static/imgV2/qietu02.png'),
				topBack: require('../../../../static/imgV2/index-left-top.png'),
				play0: require('../../../../static/imgV2/flvstop.png'),
				play1: require('../../../../static/imgV2/flvplay.png'),
				closeImg: require('../../../../static/img/close-phone.png'),
				openImg: require('../../../../static/img/open-phone.png'),
				controlButton: {
					recharge: require('../../../../static/imgV2/Recharge.png'),
					wiper: require('../../../../static/imgV2/wiper.png'),
					event: require('../../../../static/imgV2/event.png'),
					voice: require('../../../../static/imgV2/voice.png'),
					control: require('../../../../static/imgV2/control.png'),
					flv: require('../../../../static/imgV2/flv.png'),
					warning: require('../../../../static/imgV2/warning.png'),
					jtBtn: require('../../../../static/imgV2/jtbtn.png'), 
					jtBtnConst: require('../../../../static/imgV2/jtbtn.png'),	
					jtBtnCheck: require('../../../../static/imgV2/jtbtnCheck.png'),														
          rcx: require('../../../../static/imgV2/RCX.png'),
          rcxConst: require('../../../../static/imgV2/RCX.png'),
          rcxCheck: require('../../../../static/imgV2/RCXXZ.png'),
          kjg: require('../../../../static/imgV2/KJG.png'),
          kjgConst: require('../../../../static/imgV2/KJG.png'),
          kjgCheck: require('../../../../static/imgV2/KJGXZ.png'),
					rechargeCheck: require('../../../../static/imgV2/Recharge-check.png'),
					wiperCheck: require('../../../../static/imgV2/wiper-check.png'),
					eventCheck: require('../../../../static/imgV2/event-check.png'),
					voiceCheck: require('../../../../static/imgV2/voice-check.png'),
					controlCheck: require('../../../../static/imgV2/control-check.png'),
					flvCheck: require('../../../../static/imgV2/flv-check.png'),
					warningCheck: require('../../../../static/imgV2/warning-check.png'),
					rechargeConst: require('../../../../static/imgV2/Recharge.png'),
					wiperConst: require('../../../../static/imgV2/wiper.png'),
					eventConst: require('../../../../static/imgV2/event.png'),
					voiceConst: require('../../../../static/imgV2/voice.png'),
					controlConst: require('../../../../static/imgV2/control.png'),
					flvConst: require('../../../../static/imgV2/flv.png'),
					warningConst: require('../../../../static/imgV2/warning.png'),
          point: require('../../../../static/imgV2/point.png'),
          pointConst: require('../../../../static/imgV2/point.png'),
          pointCheck: require('../../../../static/imgV2/pointcheck.png'),
          rod: require('../../../../static/imgV2/s.png'),
          rodConst: require('../../../../static/imgV2/s.png'),
          rodCheck: require('../../../../static/imgV2/s-check.png'),

        },
				nowTime: new Date().getTime(),
				sliderValue: 1,
				ifAgainVoiceThen: false,
				groupInfo: {
					groupingName: "",
					schedulingName: "",
					schedulingTime: "",
					staffName: ""
				},
				mapInfo: {
					mapName: "",
					lineNames: []
				},
        iflag:true,
				robotInfo: {},
				posInfo: {},
				tapType: false,
				dialogVisible: false,
				ifShowRobot: false,
				ifShowFace: false,
				ifShowHandle: false,
				eventIds: [],
				typeList: [],
				rightUl: [],
				checkInfo: {},
				robotId: this.$route.query.robotId,
				role: this.$route.query.type,
				ifPlay: this.$route.params.ifPlay,
				ifPType: this.$route.params.ifPType,
				ifPTypeDialog: false,
				robotInfoEvent: {},
				faceInfo: {},
				playType: 'yes',
				leftInfo: {},
				flvOpen: false,
				checkFlv: {},
				ifMap: false,
				positionMap: {},
				ifSIP: false,
				ifVoice: false,
				ifAgainVoice: false,
				playStatus: false,
				playStatus1: false,
				playStatus2: false,
				playStatus3: false,
				playStatus4: false,
				playStatus5: false,
				playStatus6: false,				
				ifWiper: true,
				ifControl: false,
				ifCamera: false,
        ifRod: false,
				ifEvent: false,
				isLedgerStatus:false,//0-开始，1-结束(默认结束)
        ifPoint:false,
        				ifIndicatorLight: false,
        								
				controlStatus: true,
				ifVoiceObj: {
					useVoice: "",
					robotNumber: "",
					robotName: ""
				},
				ruleForm: {
					eType: "",
					position: ""
				},
				timeVo: {
					hour: 0,
					minute: 0,
					second: 0
				},
				radioValue: "1",
				setInter: null,
				timeEnd: false,
				ifShowLeave: false,
				attack: false,
				eventsList: [],
				changeFlvTime1: null,
				changeFlvTime2: null,
				changeFlvTime3: null,
				offVideoTime1: 600,
				offVideoTime2: 600,
				offVideoTime3: 600,
				offVideoTime4: 600,
				offVideoTime5: 600,
				changeFlvTime6: null,
                offVideoTime6: 600,
				idTypeCode: [{
					code: "1",
					name: languageJson.idCard
				}],
				personTypeCode: [],
				nextRobotId: "",
				nextTaskTime: "",
				tenantId:getItem('tenantInfoId'),
				lastStopClickTime: 0,// 记录上次急停按钮点击时间戳
				// WebRtc 相关变量
				userId: getItem('webRtcId'),
				webRtcConnection: null,
				webRtcTimer: null,
				commonPeers: false,
				callPassive: false,
			}
		},
		computed: {
		},
		mounted() {
			let that = this;
			if (that.role == 'admin') {
				that.getGroupAdmin()
			} else {
				that.getGroup()
			}
			that.$nextTick(() => {
				that.$refs.centerRightRef.addEventListener('mousewheel', (e) => {
					let down = e.wheelDelta ? e.wheelDelta < 0 : e.detail > 0
					if (down) {
						that.sliderValue = that.sliderValue <= 0 ? 1 : that.sliderValue -= 1
					} else {
						that.sliderValue = that.sliderValue > 99 ? 100 : that.sliderValue += 1
					}
				}, true)
			})
			that.robotDetail(that.robotId)
			that.personType(getItem('tenantInfoId'))
		},
		beforeDestroy() {
			let that = this
			that.clearWarning()
			that.clearEndInterval()
			if (that.warningInterval) {
				clearInterval(that.warningInterval)
				that.warningInterval = null
			}
			if (that.setInter) {
				clearInterval(that.setInter)
				that.setInter = null
			}
			if (that.changeFlvTime1) {
				clearInterval(that.changeFlvTime1)
				that.changeFlvTime1 = null
			}
			if (that.changeFlvTime2) {
				clearInterval(that.changeFlvTime2)
				that.changeFlvTime2 = null
			}
			if (that.changeFlvTime3) {
				clearInterval(that.changeFlvTime3)
				that.changeFlvTime3 = null
			}
			if (this.changeFlvTime4) {
				clearInterval(this.changeFlvTime4)
				this.changeFlvTime4 = null
			}
			if (this.changeFlvTime5) {
				clearInterval(this.changeFlvTime5)
				this.changeFlvTime5 = null
			}
			if (this.changeFlvTime6) {
				clearInterval(this.changeFlvTime6)
				this.changeFlvTime6 = null
			}
			if (that.webRtcTimer) {
				clearInterval(that.webRtcTimer)
				that.webRtcTimer = null
			}
			if (that.webRtcConnection) {
				that.webRtcConnection = null
			}
		},
		methods: {
			// WebRtc 事件监听
			listen(res){
				if (res.eventName == '__login_success') {}
				if (res.eventName == '__invite') {}
				if (res.eventName == '__peers') {
					this.commonPeers = true
					this.ifSIP = true
				}
			},
		  openPoint(){
        controlCommand({
          userId: getItem('userInfo').account + '_' + this.getNowTime + '_' + getItem('tenantInfoId'),
          number: this.robotInfo.number,
          operationType: '1'
        })
        this.ifPoint = true

      },
			CharingTask() {
				let that = this
				setCharingTask({
					robotId: '',
					type: that.rechargeValue
				}).then(res => {
					that.ifRecharge = false
					that.$notify({
						title: languageJson.successful,
						type: 'success'
					})
				})
			},
			getGroupAdmin() {
				let that = this
				getGroup(getItem('tenantInfoId')).then(res => {
					that.groupList = []
					if (res.data && res.data.length > 0) {
						res.data.forEach((res, index) => {
							that.groupList.push(res)
						})
					} else {
						that.groupList = []
					}
					that.getRobotEventDetailRobot()
				})
			},
			getGroup() {
				let that = this
				groupByDuty({
					tenantInfoId: getItem('tenantInfoId')
				}).then(res => {
					that.groupList = []
					if (res.data && res.data.dutyList.length > 0) {
						res.data.dutyList.forEach((res, index) => {
							that.groupList.push(res)
						})
					} else {
						that.groupList = []
					}
					that.getRobotEventDetailRobot()
				})
			},
			wrongFun(type, state) {
				this.evenType = type
				this.ifWrong = state
			},
			submitWrong() {
				let that = this
				reportMisIdentification({
					eventId: that.robotInfoEvent.eventId,
					remark: that.remark
				}).then(res => {
					that.ifWrong = false
					that.remark = ''
					that.$notify({
						title: languageJson.SubmitSuccess,
						type: 'success'
					})
					if (that.evenType == '1') {
						that.robotInfoEvent.isAddMisIdentification = true
					} else if (that.evenType == '2') {
						that.faceInfo.bace.isAddMisIdentification = true
					} else if (that.evenType == '3') {
						that.faceInfoOpen.bace.isAddMisIdentification = true
					} else if (that.evenType == '4') {
						that.robotInfoEventOpen.isAddMisIdentification = true
					}
				})
			},
			changeRadioValue(val) {
				this.radioValue = val
			},
			closeSip() {
				this.warningClose = false
				this.ifPTypeDialog = true
			},
			closeWarning(type) {
				let that = this
				that.ifPTypeDialog = false
				if (type == 4) {
					that.ifSIP = false
					ftRobotHangUp({
						robotNumber: that.robotInfo.number,
						tenantInfoId: getItem('tenantInfoId'),
					}).then(res => {
						if (that.warningClose && that.nextRobotId) {
							that.robotDetail(that.nextRobotId)
						}
					})
				} else if (type == '0' || type == '3') {
					that.ifSIP = false
					alarmOperate({
						robotId: that.robotId,
						robotNumber: that.robotInfo.number,
						tenantInfoId: getItem('tenantInfoId'),
						status: type == '0' ? (that.warningDate ? '1' : '0') : '3'
					}).then(res => {
						if (res.code == '200') {
							if (type == '0') {
								if (that.warningClose && that.nextRobotId) {
									that.robotDetail(that.nextRobotId)
								} else {
									that.warningFun(new Date().getTime()+10*60*1000)
								}
							} else if (type == '3') {
								that.warningBlou = false
								that.warningDate = 0
								that.clearWarning()
							}
						} else {
							that.$notify.error({
								title: res.message
							})
						}
					})
				}
			},
			linkUrl(robotId) {
				location.href = location.href.split('?')[0] + `?robotId=${robotId}&type=${this.role}`
				location.reload()
			},
			toWarning() {
				let that = this
				alarmOperate({
					robotId: that.warningObj.robotId,
					robotNumber: that.warningObj.robotNumber,
					tenantInfoId: getItem('tenantInfoId'),
					status: '0'
				}).then(res => {
					if (res.code == '200') {
						if (that.warningObj.robotId == that.robotId) {
							that.ifWarning = false
							that.warningFun(new Date().getTime()+10*60*1000)
						} else {
							that.linkUrl(that.warningObj.robotId)
						}
					} else {
						that.$notify.error({
							title: res.message
						})
					}
				})
			},
			clearWarning() {
				if (this.warningInterval) {
					clearInterval(this.warningInterval)
					this.warningInterval = null
				}
			},
			clearEndInterval() {
				if (this.ifWarningEndInterval) {
					clearInterval(this.ifWarningEndInterval)
					this.ifWarningEndInterval = null
					this.ifWarningEndNumber = 10
				}
			},
			endWarning(type) {
				let that = this
				if (type == '0') {
					that.ifWarningEnd = false
					that.clearEndInterval()
				} else {
					alarmOperate({
						robotId: that.robotId,
						robotNumber: that.robotInfo.number,
						tenantInfoId: getItem('tenantInfoId'),
						status: type
					}).then(res => {
						if (res.code == '200') {
							that.ifWarningEnd = false
							that.warningFun(new Date().getTime()+10*60*1000)
						} else {
							that.$notify.error({
								title: res.message
							})
						}
					})
				}
			},
			handleWarning(type) {
				let that = this
				alarmOperate({
					robotId: that.robotId,
					robotNumber: that.robotInfo.number,
					tenantInfoId: getItem('tenantInfoId'),
					status: type
				}).then(res => {
					if (res.code == '200') {
						that.warningBlou = false
						that.warningDate = 0
						that.ifWarningClear = false
						that.clearWarning()
					} else {
						that.$notify.error({
							title: res.message
						})
					}
				})
			},
			warningFun(timeNumber) {
				let that = this
				that.clearWarning()
				let resTimer = Math.trunc((timeNumber - new Date().getTime())/1000);
				that.warningBlou = resTimer > 0 ? true : false
				that.warningInterval = setInterval(() => {
					resTimer -= 1
					that.warningDate = resTimer > 0 ? that.secondsToTime(resTimer) : 0
					if (resTimer <= 0) {
						clearInterval(that.warningInterval)
						that.warningInterval = null
					}
				}, 1000)
			},
			secondsToTime(seconds) {
				var minutes = Math.floor((seconds) / 60);
				var seconds = seconds - (minutes * 60);
				seconds = Math.round(seconds * 100) / 100;
				var result = (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
				return result;
			},
			getRobotEventDetailRobot(id) {
				let that = this
				let groupAry = [];
				that.groupList.map(res => groupAry.push(res.groupingId))
				getRobotEventList(groupAry.toString(), getItem('tenantInfoId'), '1', '1').then(res => {
					if (res && res.data.length > 0) {
						that.openAry = res.data
					}
				})
				// getRobotEventDetailRobot(id, getItem('tenantInfoId'),'1', '1').then(res => {
				// 	if (res && res.data) {
				// 		that.openAry = res.data
				// 	}
				// })
			},
			closeOpenEvent() {
				let that = this
				that.$refs.scrollContainer.scrollTop = 0;
				let groupAry = [];
				that.groupList.map(res => groupAry.push(res.groupingId))
				if (that.openAry.length > 1) {
					getRobotEventList(groupAry.toString(), getItem('tenantInfoId'), '1', '1').then(res => {
						if (res && res.data.length > 0) {
							that.openAry = res.data
							that.openState = that.openAry[0].operationType == '3' ? 'face' : 'imgs'
							that.showRobot(that.openAry[0], true)
						} else if (res.data.length == 0) {
							that.openAry = []
							that.eventDialog = false
						}
					})
				} else {
					that.openAry = []
					that.eventDialog = false
				}
			},
			openDialog() {
				this.eventDialog = true
				this.checkImg = 0
				this.$refs.scrollContainer.scrollTop = 0
				if (this.openAry.length > 0) {
					this.openState = this.openAry[0].operationType == '3' ? 'face' : 'imgs'
					this.showRobot(this.openAry[0], true)
				}
			},
			drawOpenEvent(obj, index) {
				this.checkImg = index
				this.openState = obj.operationType == '3' ? 'face' : 'imgs'
				this.showRobot(obj, true)
			},
			personType(tId) {
				let that = this
				personType({
					tenantInfoId: tId
				}).then(res => {
					if (res) {
						that.personTypeCode = res.data
					}
				})
			},
			setVideoEnd(type) {
				let that = this
				that['playStatus'+ type] = true  
				if (that['changeFlvTime' + type]) {
					window.clearInterval(that['changeFlvTime' + type])
					that['changeFlvTime' + type] = null
				}
				that['offVideoTime' + type] = 600
				that['changeFlvTime' + type] = window.setInterval(function() {
					that['offVideoTime' + type] -= 1
					if (that['offVideoTime' + type] <= 0) {
					that['playStatus' + type] = false
					window.clearInterval(that['changeFlvTime' + type])
					that['changeFlvTime' + type] = null
					if (that.robotInfo.robotType == '06') {
				        that.initRobot06Camera();
					} else if(that.robotInfo.tenantInfoId ==  "2847ec53457c42a88a87ca7d462e5dde") {
						// 新增：指定租户的重置逻辑
						that.checkInfo = {
						name: languageJson.PanTiltCamera,
						src: that.robotInfo.flvPtz
						}
						that.leftInfo = {
						leftName: languageJson.ThermalImagingLight,
						leftSrc: that.robotInfo.flvThermLight,
						rightName: languageJson.ThermalImaging,
						rightSrc: that.robotInfo.flvTherm,
						rightNameTwo: languageJson.LeftCamera,
						rightSrcTwo: that.robotInfo.rLeft,
						rightNameThree: languageJson.RightCamera,
						rightSrcThree: that.robotInfo.rRight,
						}
					} else {
						that.checkInfo = {
						name: languageJson.PanTiltCamera,
						src: that.robotInfo.flvPtz
						}
						that.leftInfo = {
						leftName: languageJson.ThermalImagingLight,
						leftSrc: that.robotInfo.flvThermLight,
						rightName: languageJson.ThermalImaging,
						rightSrc: that.robotInfo.flvTherm
						}
					}
					}
				}, 1000)
			},
			closeEvent(index) {
				this.eventsList.splice(index, 1)
			},
			changeMusic() {
        console.log("账号账号账号")
        console.log(localStorage.getItem('userInfo'))
        console.log(getItem('userInfo').account)
        this.who = JSON.parse(localStorage.getItem('userInfo'))
        console.log(this.who.account)
        if (this.who.account != 'jbzstaff2' && this.who.account != 'jbzstaff1' && this.who.account != 'jbzstaff3' && this.who.account != 'jbzstaff2' && this.who.account != 'jrcsatff3'){
          this.attack = false
        }else{
          if (this.attack == true){
            this.$refs.eventAudio.play()
          }
        }
			},
			oneHandle() {
				let that = this
				handleEventBatch({
					eventList: that.eventIds,
					userId: getItem('userInfo').staffId,
					tenantInfoId: getItem('tenantInfoId')
				}).then(res => {
					that.ifShowHandle = false
				})
			},
			showHandle(getEventIds) {
				this.eventIds = getEventIds
				this.ifShowHandle = true
			},

      addPoint(){
        if(!this.pointObj.ptype){
          this.$notify({
            title: '请选择点位类型',
            type: 'warning'
          })
          return
        }
        if(this.pointObj.ptype == '1' && !this.pointObj.eventType ){
          this.$notify({
            title: '请选择事件类型',
            type: 'warning'
          })
          return
        }
        if(!this.pointObj.name ){
          this.$notify({
            title: '请选输入名称',
            type: 'warning'
          })
          return
        }
        if(this.pointObj.ptype == '1' && this.pointObj.eventType == 'E0001' && !this.pointObj.fileType  ){
          this.$notify({
            title: '请选择上传类型',
            type: 'warning'
          })
          return
        }
        if(this.pointObj.ptype == '1' && this.pointObj.eventType == 'E0001' && this.pointObj.fileType == '1' && !this.pointObj.videoType ){
          this.$notify({
            title: '请选择录制方式',
            type: 'warning'
          })
          return
        }
			// 2. 开关控制（增加防重复点击提示）
			if (!this.iflag) {
				this.$notify({ title: '操作中，请稍候', type: 'info' });
				return;
			}
			this.iflag = false; // 关闭开关
			const resetIflag = () => { this.iflag = true; }; // 封装重置逻辑

			try {
				// 3. 室内机（04/05类型）添加打卡点逻辑
				if (['04', '05'].includes(this.robotInfo.robotType)) {
				positonInfo({
					robotId: this.robotInfo.robotId,
					userId: getItem('userInfo').staffId
				}).then(res => {
					const positionValue = res.data && res.data.positon ? res.data.positon : '';
					const param = {
					...this.pointObj,
					staffId: getItem("userInfo").staffId,
					number: this.robotInfo.number,
					tenantInfoId: getItem("tenantInfoId"),
					socketId: `${getItem("userInfo").account}_${new Date().getTime()}_${getItem("tenantInfoId")}`,
					position: positionValue
					};
					return setFloorPositon(param);
				})
				.then(data => {
					this.$notify({ title: '添加成功', type: 'success' });
					this.pointOff(); // 关闭弹窗并重置表单
				})
				.catch(err => {
					console.error('添加点位失败：', err);
					this.$notify({ title: '添加失败，请重试', type: 'error' });
				})
				.finally(() => {
					resetIflag(); // 无论成功/失败，都重置开关
				});
				} 
				// 4. 室外机添加逻辑
				else {
				const param = {
					...this.pointObj,
					number: this.robotInfo.number,
					eventId: this.pointObj.eventType
				};

				// 打卡点/路线点区分
				const requestFn = this.pointObj.ptype == '1' ? setPositon : setCoord;
				
				requestFn(param)
					.then(data => {
					this.$notify({ title: '添加成功', type: 'success' });
					this.pointOff();
					})
					.catch(err => {
					console.error('添加点位失败：', err);
					this.$notify({ title: '添加失败，请重试', type: 'error' });
					})
					.finally(() => {
					resetIflag(); // 重置开关
					});
				}
			} catch (err) {
				console.error('添加点位异常：', err);
				this.$notify({ title: '系统异常，请重试', type: 'error' });
				resetIflag(); // 异常时也重置开关
			}
		},

		// 修复取消按钮：增加iflag重置
		pointOff() {
		this.pointObj = {
			ptype: "",
			eventType: "",
			name: "",
			remark: "",
			fileType: "",
			videoType: "",
			videoTime: 10,
			fireExtinguisherNum: 2,
			threshold: "",
			unit: "",
		};
		controlCommand({
			userId: `${getItem('userInfo').account}_${new Date().getTime()}_${getItem('tenantInfoId')}`,
			number: this.robotInfo.number,
			operationType: '2'
		});
		this.ifPoint = false;
		this.iflag = true; // 重置开关，确保下次可点击
		},
			addEvent() {
				let that = this
				that.ruleForm.number = that.robotInfo.number
				if (!that.ruleForm.eType) {
					that.$notify({
						title: languageJson.selectEventType,
						type: 'warning'
					})
					return false
				}
				if (!that.ruleForm.position) {
					that.$notify({
						title: languageJson.PleaseProcessing,
						type: 'warning'
					})
					return false
				}
				addEvent({
					eType: that.ruleForm.eType,
					position: that.ruleForm.position,
					tenantInfoId: getItem('tenantInfoId'),
					number: that.robotInfo.number,
					userId: getItem('userInfo').staffId
				}).then(res => {
					that.$notify({
						title: languageJson.successful,
						type: 'success'
					})
					that.eventOff()
				})
			},

			eventOff() {
				this.ruleForm.eType = ""
				this.ruleForm.position = ""
				this.ifEvent = false
			},
			getReportEventTypeByRobotId(_id) {
				let that = this
				getReportEventTypeByRobotId(_id).then(res => {
					that.typeList = []
					if (res.data.length > 0) {
						res.data.forEach(v => {
							that.typeList.push(v)
						})
					}
				})
			},
			ptzWiper() {
				let that = this
				if (that.ifWiper) {
					that.ifWiper = false
					ptzWiper({
						tenantInfoId: getItem('tenantInfoId'),
						number: that.robotInfo.number
					}).then(res => {
						setTimeout(() => {
							that.ifWiper = true
						}, 2000)
					})
				}
			},
			playStop(type, num) {
				if (num == '1') {
					this.playStatus = (type == 'play') ? true : false
				} else if (num == '2') {
					this.playStatus1 = (type == 'play') ? true : false
				} else if (num == '3') {
					this.playStatus2 = (type == 'play') ? true : false
				} else if (num == '4') {
					this.playStatus3 = (type == 'play') ? true : false
				} else if (num == '5') {
					this.playStatus4 = (type == 'play') ? true : false
				} else if (num == '6') {
					this.playStatus5 = (type == 'play') ? true : false
				}else if (num == '7') { // 新增playStatus6状态更新
					this.playStatus6 = (type == 'play') ? true : false
				}
			},
			backLink() {
				if (getItem('userInfo').positionType == '1') {
					this.$router.push({
						name: 'admin'
					})
				} else {
					this.$router.push({
						name: 'user'
					})
				}
			},
			closeVoice() {
				let that = this
				that.$confirm(that.languageJson.ConfirmHangUp, that.languageJson.prompt, {
					confirmButtonText: that.languageJson.end,
					cancelButtonText: that.languageJson.Cancel,
					type: "warning",
				}).then(() => {
					that.ifVoice = false
				}).catch(() => {})
			},
			// 【完整WebRtc呼叫方法】
			callPhone() {
				console.log('✅呼叫方法--') 
				let that = this
				that.activePhone = true

				// ===== 新增防御判断 =====
				if (!that.robotInfo || !that.robotInfo.number) {
					that.$notify.warning({ title: '机器人信息未加载，无法呼叫' })
					return
				}

				if (that.ifSIP) {
					that.$notify.warning({
					title: languageJson.currentlyCommunication
					})
				} else {
					// 【恢复2023-06原始非私有化逻辑】不走自建信令(WebRtc.js)，直接弹出SIPAudio
					// 弹框后由 SIPAudio 内部 switchWebRtc 接口通知机器人，双方走网易云信 NERTC 会合
					// that.webRtcConnection = new WebRtc({userId: that.userId, listen: that.listen, passive: false});
					// setTimeout(() => {
					// that.webRtcConnection.createRoom({room: that.robotInfo.number + "_room"});
					// },1000)
					callCount({
					robotId: that.nextRobotId ? that.nextRobotId : that.robotId,
					type: "2"
					}).then(res => {})
					that.ifVoiceObj.useVoice = '2'
					that.ifVoiceObj.robotNumber = that.robotInfo.number
					that.ifVoiceObj.robotName = that.robotInfo.robotName
					that.ifSIP = true // 原始逻辑：直接弹框，不等信令 __peers
			    }
			},
			handelStopClick() {
				const now = Date.now();
				const COOLDOWN_MS = 5000; // 5秒冷却时间
			   // 防抖拦截：5秒内禁止重复点击
			   if (this.lastStopClickTime && (now - this.lastStopClickTime) < COOLDOWN_MS) {
					this.$notify({
					title: '提示',
					message: '请不要频繁点击，至少5秒后再尝试',
					type: 'warning'
					});
					return;
				}
				// 记录本次点击时间
				this.lastStopClickTime = now;
				const targetStatus = this.robotInfo.buttonStop === '1' ? '0' : '1';
				const param = {
					robotNumber: this.robotInfo.number,
					buttonStop: targetStatus,
				};
				sendButtonStop(param).then(data => {
					this.$notify({
					title: '状态改变成功',
					type: 'success'
					})
				}).catch(err => {
					this.lastStopClickTime = 0;
					this.$notify({
					title: '操作失败',
					type: 'error'
					})
				})
			},
			openVoiceThen() {
				let that = this
				that.ifVoice = false
				that.ifAgainVoiceThen = false
				that.ifPlay = true
				if (that.ifPType) {
					if (that.warningDate) {
						that.ifPTypeDialog = true
					} else {
						that.ifSIP = false
						that.robotDetail(that.nextRobotId)
					}
				} else {
					that.ifSIP = false
					that.robotDetail(that.nextRobotId)
				}
			},
			// 【完整WebRtc接听方法】
			openVoice() {
				let that = this
				if (that.ifAgainVoice) {
					that.ifAgainVoiceThen = true
				} else {
					if (that.nextRobotId && (that.robotInfo.robotId != that.nextRobotId)) {
					that.openVoiceThen()
					} else {
					// ===== 优化：防止重复实例 =====
					if (that.webRtcConnection) {
						console.log("✅WebRtc 已存在，跳过重复创建")
						that.ifVoice = false
						return
					}

					that.webRtcConnection = new WebRtc({userId: that.userId, listen: that.listen, passive: true});
					setTimeout(() => {
						that.webRtcConnection.createRoom({room: that.robotInfo.number + "_room"});
					}, 1000)
					that.ifVoice = false
					saveRobotHistory({
						"staffId": getItem('userInfo').staffId,
						"client": "2"
					}).then(res => {})
					}
				}
			},
			showMap() {
				this.ifMap = true
			},
			openHotFlv() {
        this.ifHotFlv = !this.ifHotFlv
			},
      openHotLightFlv() {
        this.ifHotLightFlv = !this.ifHotLightFlv
      },
			robotX2(data) {
				this.checkFlv = data
				this.flvOpen = true
			},
			flvPlay(type, num) {
				if (num == 1) {
					this.playStatus = !type;
				} else if (num == 2) {
					this.playStatus1 = !type;
				} else if (num == 3) {
					this.playStatus2 = !type;
				} else if (num == 4) {
					this.playStatus3 = !type;
				} else if (num == 5) {
					this.playStatus4 = !type;
				} else if (num == 6) {
					this.playStatus5 = !type;
				} else if (num == 7) { // 新增playStatus6控制
					this.playStatus6 = !type;
				}
			},
			getPtz() {
				let that = this
				getPtz({
					tenantInfoId: getItem('tenantInfoId'),
					number: that.robotInfo.number
				}).then(res => {
					that.sliderValue = Number(res.data.focal)
				})
			},
			// 切换机器人
			changeRobot(vid) {
				this.linkUrl(vid)
			},
      eventTypeByRobotId(number){
        getReportEventTypeByRobotId(number).then(res=>{
          console.log("事件类型")
          console.log(res.data)
		   // this.selectEvents = res.data.filter(re=> re.patrolFlg)
          this.selectEvents = res.data
        })
      },
	  handleLedgerStatus(number){
        getLedgerStatus(number).then(res=>{
		    this.isLedgerStatus = res.data.ledgerStatus || false
			console.log("获取台账状态呀呀呀呀呀呀----",this.isLedgerStatus)
        })
      },
		changeLedgerStatus(){
		// 兼容写法：防止无机器人信息时调用接口
		if(!this.robotInfo || !this.robotInfo.number){
			this.$notify.warning({ title: '提示', message: '机器人信息异常' })
			this.isLedgerStatus = !this.isLedgerStatus
			return
		}
		let param = {
			robotNumber:this.robotInfo.number,
			ledgerStatus:this.isLedgerStatus ? '0' : '1' //0-开始，1-结束
		}
		switchLedger(param).then(res=>{
			console.log("切换台账状态成功",this.isLedgerStatus)
			// 成功提示
			this.$notify({
			title: '操作成功',
			message: this.isLedgerStatus ? '台账状态已开启' : '台账状态已关闭',
			type: 'success'
			})
		}).catch(err=>{
			// 失败回退+提示
			this.isLedgerStatus = !this.isLedgerStatus
			this.$notify.error({
			title: '操作失败',
			message: '台账状态切换失败，请重试'
			})
			console.error('切换台账状态接口报错：', err)
		})
		},
	// 添加视频流设置方法
		setVideoStream() {
					let that = this;
					// (私有化部署)且已获取M3U8数据
					if ((that.isPrivate) && Object.keys(that.videoData).length > 0) {
						console.log('私有化部署设置视频流:', that.videoData);
						// 根据视频流字段分配摄像头
						const videoSources = that.videoData;
						// 分配主摄像头（云台摄像头）
						if (videoSources.preposition) {
							that.checkInfo = {
								name: that.languageJson.PanTiltCamera,
								src: videoSources.preposition
							};
						} else {
							console.warn('私有化部署缺少云台摄像头(preposition)视频流');
						}
						that.leftInfo = {
							leftName: that.languageJson.ThermalImagingLight,
							leftSrc: videoSources.holder,
							rightName: that.languageJson.ThermalImaging,
							rightSrc: videoSources.thermal
						};
						console.log('视频流分配结果:', {
							checkInfo: that.checkInfo,
							leftInfo: that.leftInfo
						});
					}
		},
        initRobot06Camera() {
			let that = this;
			 
			if (!that.isPrivate && that.robotInfo.robotType === '06') {
				that.checkInfo = {
					name: that.languageJson.PanTiltCamera, //云台摄像头
					src: that.robotInfo.flvPtz || ''
				};
				that.leftInfo = {
					frontName: that.languageJson.FrontCamera, //前视摄像头
					frontSrc: that.robotInfo.flvThermLight,
					backName: that.languageJson.BackCamera, //后视摄像头
					backSrc: that.robotInfo.rBack,
					leftName: that.languageJson.LeftCamera,//左视摄像头
					leftSrc: that.robotInfo.rLeft,
					rightName: that.languageJson.RightCamera,//右视摄像头
					rightSrc: that.robotInfo.rRight,
					upName: that.languageJson.UpCamera || '上视频摄像头',
					upSrc: that.robotInfo.rUp,
					thermName: that.languageJson.ThermalImaging, //热成像
					thermSrc: that.robotInfo.flvTherm
				};
				// 确保响应式更新
				that.checkInfo = JSON.parse(JSON.stringify(that.checkInfo));
				that.leftInfo = JSON.parse(JSON.stringify(that.leftInfo));
				console.log('✅进入页面获取视频流呀呀呀呀呀------',that.leftInfo)
			}
		},
		robotDetail(id) {
					let that = this
					that.leftInfo = {}
					that.checkInfo = {}
					that.playStatus = false
					that.playStatus1 = false
					that.playStatus2 = false
					that.playStatus3 = false
					that.playStatus4 = false
					that.playStatus5 = false
					that.robotId = id
					
					getRobotEventDetail(id, getItem('tenantInfoId')).then(res => {
						if (res && res.data) {
							that.rightUl = res.data
						}
					})
					
					robotDetail(id).then(res => {
						if (res && res.data) {
							that.eventTypeByRobotId(res.data.number)
							that.handleLedgerStatus(res.data.number)
							if (Number(res.data.standbyEndTime)) {
								that.warningObj = {
									robotId: res.data.robotId,
									robotName: res.data.robotName,
									robotNumber: res.data.number,
								}
								that.warningFun(Number(res.data.standbyEndTime))
							}
							
							that.getReportEventTypeByRobotId(res.data.number)
							
							if (that.ifPlay) {
								setTimeout(() => {
									that.ifSIP = true
									that.ifVoiceObj.useVoice = "2"
									that.ifVoiceObj.robotNumber = res.data.number
									that.ifVoiceObj.robotName = res.data.robotName
									saveRobotHistory({
										"staffId": getItem('userInfo').staffId,
										"client": "2"
									}).then(res => {})
								}, 1000)
							}
							// 修改后的逻辑：先获取M3U8视频流地址，然后再设置机器人信息
							if (that.isPrivate ) {
								// 先获取M3U8视频流地址 //res.data.number 'ROB25080181'
								getM3u8Video({number:res.data.number }).then(m3u8Res => {
									if (m3u8Res && m3u8Res.data) {
										that.videoData = m3u8Res.data ;//m3u8Res.data
										console.log('获取到M3U8视频流数据:', that.videoData);
										this.isStart = true
										// 更新机器人信息
										that.robotInfo = res.data;
										// 立即设置视频流地址
										that.setVideoStream();
									} else {
										console.warn('M3U8数据为空，使用默认视频流');
										that.robotInfo = res.data;
									}
								}).catch(error => {
									console.error('获取M3U8视频流失败:', error);
									that.robotInfo = res.data;
								});
							}else {
								// 非私有化部署，直接使用原有数据
								that.robotInfo = res.data;
							}
						}
					})
					
					mapRoute(id).then(res => {
						if (res && res.data) {
							that.mapInfo = res.data
						}
					})
					
					currentDuty(id).then(res => {
						if (res && res.data) {
							that.groupInfo = res.data
						}
					})
				},
			showRobot(vo, openType) {
				let that = this
				getRobotEventInfo(vo.eventId).then(res => {
          that.attack = false;
					if (res.data && res.data.imgList.length == 0) {
						that.$notify({
							title: languageJson.noImage,
							type: 'warning'
						})
					} else {
						that.robotInfoEvent = res.data
						that.robotInfoEventOpen = res.data
						if (res.data.operationType == '3') {
							that.getCompletionInfo(res.data, openType)
						} else {
							if (!openType) {
								that.ifShowRobot = true
							}
						}
					}
				})
			},
			getCompletionInfo(bace,openType) {
				let that = this
				completionInfo({
					faceDatebaceId: bace.faceDatabaceId
				}).then(resFace => {
					if (!openType) {
						that.ifShowFace = true
					}
					that.faceInfo = {
						bace,
						...resFace.data
					}
					that.faceInfo.similarity = (Number(bace.similarity) * 100).toFixed(2)
					that.faceInfo.registerPhotos = bace.registerPhotos
					that.faceInfo.snapPhotos = bace.snapPhotos
					if (resFace.data.idType) {
						that.faceInfo.idType = that.idTypeCode.find(rev => rev.code == resFace.data.idType).name
					} else {
						that.faceInfo.idType = '--'
					}
					if (resFace.data.personTypeId) {
						that.faceInfo.personTypeId = that.personTypeCode.find(rev => rev.personTypeId == resFace.data.personTypeId).typeName
					} else {
						that.faceInfo.personTypeId = '--'
					}
					that.faceInfoOpen = that.faceInfo
				})
			},
			changeRtmp(type, src) {
				        console.log('切换了开始-----',type, src)
						let that = this
						that.playStatus = true
						if (type == 'leftName') that.playStatus1 = true
						if (type == 'rightName') that.playStatus2 = true
						if (type == 'backName') that.playStatus3 = true
						if (type == 'rightNameTwo') that.playStatus4 = true  // 新增 用于公安一所 
						if (type == 'rightNameThree') that.playStatus5 = true // 新增 用于公安一所 	

					        if (type == 'upName') that.playStatus5 = true    // 新增upName
							if (type == 'thermName') that.playStatus6 = true // 新增thermName	
						// 私有化部署的切换逻辑
						if ((that.isPrivate) && Object.keys(that.videoData).length > 0) {
							console.log('私有化部署切换视频流，使用M3U8地址',that.leftInfo[type],that.languageJson.PanTiltCamera);
							// 私有化部署只有三个摄像头，处理方式简化
								if (that.leftInfo[type] == that.languageJson.PanTiltCamera) {
									// 如果点击的是云台摄像头，恢复原始状态
									that.leftInfo = {
										leftName: that.languageJson.ThermalImagingLight, // 前视摄像头
										leftSrc: that.videoData.holder,
										rightName: that.languageJson.ThermalImaging, // 热成像摄像头
										rightSrc: that.videoData.thermal
									}
									that.checkInfo.name = that.languageJson.PanTiltCamera
									that.checkInfo.src = that.videoData.preposition
									console.log('that.leftInfo',that.leftInfo)
								} else {
									// 点击小画面摄像头，将其设为主画面
									const originalLeftInfo = {
										leftName: that.languageJson.FrontCamera,
										leftSrc: that.videoData.holder,
										rightName: that.languageJson.ThermalImaging,
										rightSrc: that.videoData.thermal
									};
									
									// 将点击的摄像头设为主画面
									that.checkInfo.name = that.leftInfo[type]
									that.checkInfo.src = that.leftInfo[src]
									// 重新分配小画面：一个放云台摄像头，另一个放未点击的摄像头
									if (type === 'leftName') {
										// 点击了左侧，右侧不变，左侧放云台摄像头
										that.leftInfo = {
											leftName: that.languageJson.PanTiltCamera,
											leftSrc: that.videoData.preposition,
											rightName: originalLeftInfo.rightName,
											rightSrc: originalLeftInfo.rightSrc
										}
									} else if (type === 'rightName') {
										// 点击了右侧，左侧不变，右侧放云台摄像头
										that.leftInfo = {
											leftName: originalLeftInfo.leftName,
											leftSrc: originalLeftInfo.leftSrc,
											rightName: that.languageJson.PanTiltCamera,
											rightSrc: that.videoData.preposition
										}
									}
							
							}
							// 确保数据响应式更新
							that.checkInfo = JSON.parse(JSON.stringify(that.checkInfo))
							that.leftInfo = JSON.parse(JSON.stringify(that.leftInfo))
							
						} else {
							// 原有非私有化部署逻辑保持不变
							if (that.robotInfo.robotType == '06') {
								  // 修改：robotType=06非私有化时的切换逻辑
								if (that.leftInfo[type] == that.languageJson.PanTiltCamera) {
									// 恢复原始状态：主屏幕云台，小屏幕6个摄像头
									 that.initRobot06Camera();
									// 单独设置主画面（云台摄像头）
									that.checkInfo.name = that.languageJson.PanTiltCamera
									that.checkInfo.src = that.robotInfo.flvPtz
									that.checkInfo = JSON.parse(JSON.stringify(that.checkInfo))
								} else {
									// 点击小画面摄像头，将其设为主画面
									// 第一步：先调用封装方法，初始化基础摄像头数据
									that.initRobot06Camera();
									// 第二步：处理「点击小摄像头切换主画面」的逻辑（修正src变量错误）
									// 核心：把 type（比如frontName）拆分成 名称前缀 + Src 后缀，找到对应的流地址
									const srcKey = type.replace('Name', 'Src'); // 比如 frontName → frontSrc
									that.checkInfo.name = that.leftInfo[type]; // 主画面名称 = 点击的小摄像头名称
									that.checkInfo.src = that.leftInfo[srcKey]; // 主画面流地址 = 点击的小摄像头流地址
									that.checkInfo = JSON.parse(JSON.stringify(that.checkInfo));
									// 第三步：把云台摄像头替换到点击的小摄像头位置
									that.leftInfo[type] = that.languageJson.PanTiltCamera; // 小摄像头名称改为云台
									that.leftInfo[srcKey] = that.robotInfo.flvPtz; // 小摄像头流地址改为云台地址
								}
							} else if(that.robotInfo.tenantInfoId ==  "2847ec53457c42a88a87ca7d462e5dde") {
								if (that.leftInfo[type] == that.languageJson.PanTiltCamera) {
									that.leftInfo = {
										leftName: that.languageJson.ThermalImagingLight,
										leftSrc: that.robotInfo.flvThermLight,
										rightName: that.languageJson.ThermalImaging,
										rightSrc: that.robotInfo.flvTherm,
										rightNameTwo: languageJson.LeftCamera,//左视
										rightSrcTwo: that.robotInfo.rLeft,
										rightNameThree: languageJson.RightCamera,////右视
										rightSrcThree: that.robotInfo.rRight,
									}
									that.checkInfo.name = that.languageJson.PanTiltCamera
									that.checkInfo.src = that.robotInfo.flvPtz
									that.checkInfo = JSON.parse(JSON.stringify(that.checkInfo))
								} else {
									that.leftInfo = {
										leftName: that.languageJson.ThermalImagingLight,
										leftSrc: that.robotInfo.flvThermLight,
										rightName: that.languageJson.ThermalImaging,
										rightSrc: that.robotInfo.flvTherm,
										rightNameTwo: languageJson.LeftCamera,//左视
										rightSrcTwo: that.robotInfo.rLeft,
										rightNameThree: languageJson.RightCamera,////右视
										rightSrcThree: that.robotInfo.rRight,

									}
									that.checkInfo.name = that.leftInfo[type]
									that.checkInfo.src = that.leftInfo[src]
									that.checkInfo = JSON.parse(JSON.stringify(that.checkInfo))
									that.leftInfo[type] = that.languageJson.PanTiltCamera
									that.leftInfo[src] = that.robotInfo.flvPtz
								}
							}else {
								console.log('--------that.leftInfo[type]-----------', that.leftInfo[type], 'that.robotInfo', that.robotInfo)
								if (that.leftInfo[type] == that.languageJson.PanTiltCamera) {
									that.leftInfo = {
										leftName: that.languageJson.ThermalImagingLight,
										leftSrc: that.robotInfo.flvThermLight,
										rightName: that.languageJson.ThermalImaging,
										rightSrc: that.robotInfo.flvTherm
									}
									that.checkInfo.name = that.languageJson.PanTiltCamera
									that.checkInfo.src = that.robotInfo.flvPtz
									that.checkInfo = JSON.parse(JSON.stringify(that.checkInfo))
								} else {
									that.leftInfo = {
										leftName: that.languageJson.ThermalImagingLight,
										leftSrc: that.robotInfo.flvThermLight,
										rightName: that.languageJson.ThermalImaging,
										rightSrc: that.robotInfo.flvTherm
									}
									that.checkInfo.name = that.leftInfo[type]
									that.checkInfo.src = that.leftInfo[src]
									that.checkInfo = JSON.parse(JSON.stringify(that.checkInfo))
									that.leftInfo[type] = that.languageJson.PanTiltCamera
									that.leftInfo[src] = that.robotInfo.flvPtz
								}
							}
							that.leftInfo = JSON.parse(JSON.stringify(that.leftInfo))
						}
						//  this.$nextTick(() => {
						// 	this.checkInfo = { ...this.checkInfo };
						// 	this.leftInfo = { ...this.leftInfo };
						// });
		    },
			doSocker(socketData) { 
                console.log('✅socketType:',socketData.socketType,'✅socketData:',socketData)
				let that = this
				that.vSocketVos = socketData
				if (socketData.socketType == '1') {
					if (that.robotInfo.robotId == socketData.robotId) {
						that.nextTaskTime = socketData.nextTaskTime
						that.robotInfo.ststus = socketData.ststus
						that.robotInfo.ststusName = that.languageCheck == 'English' ? socketData.enStstusName : socketData.ststusName
						that.robotInfo.power = socketData.power
						that.posInfo = socketData
						that.robotInfo.buttonStop = socketData.buttonStop
					}
				} else if (socketData.socketType == '2') {
					if (that.robotInfo.robotId == socketData.robotId) {
						that.getRobotEventDetailRobot(that.robotId)
						let newSocketDataObj = socketData;
						if (that.languageCheck == 'English') {
							newSocketDataObj.resultsName = newSocketDataObj.enResultsName
							newSocketDataObj.eventlnsDate = newSocketDataObj.enEventlnsDate
							newSocketDataObj.eName = newSocketDataObj.eEnName
						}
						that.rightUl.unshift(newSocketDataObj)
						if (socketData.disShowFlg == '1' && socketData.results != '5' && (!that.ifControl && !that.ifCamera) && that.role == 'user') {
							if (that.attack != true){
                that.$refs.eventAudio.play()
                that.attack = true
                setTimeout(() => {}, 3000)
              }
						}
					}
				} else if (socketData.socketType == '4') {
					if (that.robotInfo.robotId == socketData.robotId) {
						let typeSocketData4 = socketData;
						that.getRobotEventDetailRobot(that.robotId)
						if (that.languageCheck == 'English') {
							typeSocketData4.resultsName = socketData.enResultsName
							typeSocketData4.eventlnsDate = socketData.enEventlnsDate
							typeSocketData4.eName = socketData.eEnName
						}
						that.rightUl.unshift(typeSocketData4)
					}
				} else if (socketData.socketType == '6') {
					let typeSocketData6 = socketData
					that.getRobotEventDetailRobot(that.robotId)
					if (that.languageCheck == 'English') {
						typeSocketData6.resultsName = socketData.enResultsName
						typeSocketData6.eventlnsDate = socketData.enEventlnsDate
						typeSocketData6.eName = socketData.eEnName
					}
					if (socketData.results == "1" || socketData.results == "3" || socketData.results == "5") {
						for (let i = 0; i < that.rightUl.length; i++) {
							if (that.rightUl[i].eventId == socketData.eventId) {
								that.rightUl.splice(i, 1)
								that.rightUl.unshift(typeSocketData6)
							}
						}
					} else {
						for (let i = 0; i < that.rightUl.length; i++) {
							if (that.rightUl[i].eventId == socketData.eventId) {
								that.rightUl[i] = typeSocketData6
							}
						}
					}
          that.rightUl = JSON.parse(JSON.stringify(that.rightUl))
				} else if (socketData.socketType == '8') {
				 	that.timeEnd = true
				 	that.setInter = window.setInterval(function() {
				 		if (that.timeVo.second >= 60) {
				 			that.timeVo.second = 0
				 			that.timeVo.minute += 1
				 			if (that.timeVo.minute >= 60) {
				 				that.timeVo.minute = 0
				 				that.timeVo.hour += 1
				 			}
				 		} else {
				 			that.timeVo.second += 1
				 		}
				 	}, 1000)
				 } else if (socketData.socketType == '9') {
				 	that.ifControl = false
				 	that.timeEnd = false
					that.controlStatus = true
				 	that.timeVo = {
				 		hour: 0,
				 		minute: 0,
				 		second: 0
				 	}
				 	window.clearInterval(that.setInter)
				 	that.setInter = null;
				 } else if (socketData.socketType == '10') {
				 	that.$notify.error({
				 		title: languageJson.AbnormalControl
				 	})
				 	that.ifControl = false
				 	that.timeEnd = false
				 	that.timeVo = {
				 		hour: 0,
				 		minute: 0,
				 		second: 0
				 	}
				 	window.clearInterval(that.setInter)
				 	that.setInter = null;
				 } else if (socketData.socketType == '17') {
					if (socketData.status == '0') {
						that.activePhone = false
						that.ifVoice = true
						that.ifPType = false
						that.ifVoiceObj.useVoice = socketData.useVoice
						that.ifVoiceObj.robotNumber = socketData.robotNumber
						that.ifVoiceObj.robotName = socketData.robotName
						if (that.ifSIP) {
							if (socketData.robotNumber != that.robotInfo.number) {
								that.ifAgainVoice = true
								that.nextRobotId = socketData.robotId
							}
							that.ifAgainVoice = true
							that.nextRobotId = socketData.robotId
						} else {
							that.nextRobotId = that.robotInfo.robotId != socketData.robotId ? socketData.robotId : ""
							that.ifAgainVoice = false
						}
					} else {
						if (that.ifVoiceObj.robotNumber == socketData.robotNumber) {
							that.ifVoice = false
							that.ifSIP = false
						}
					}
				} else if (socketData.socketType == '22') {
					if (socketData.robotId == that.robotId) {
						mapRoute(that.robotId).then(res => {
							if (res && res.data) {
								that.mapInfo = res.data
							}
						})
					}
				} else if (socketData.socketType == '23') {
					if (socketData.status == '0') {
						that.activePhone = false
						that.ifVoice = true
						that.ifPType = true
						that.ifVoiceObj.useVoice = socketData.useVoice
						that.ifVoiceObj.robotNumber = socketData.robotNumber
						that.ifVoiceObj.robotName = socketData.robotName
						if (that.ifSIP) {
							if (socketData.robotNumber != that.robotInfo.number) {
								that.warningClose = true
								that.ifAgainVoice = true
								that.nextRobotId = socketData.robotId
							}
						} else {
							that.nextRobotId = that.robotInfo.robotId != socketData.robotId ? socketData.robotId : ""
							that.ifAgainVoice = false
						}
					} else {
						if (that.ifVoiceObj.robotNumber == socketData.robotNumber) {
							that.ifVoice = false
							that.ifSIP = false
						}
					}
				} else if (socketData.socketType == '24') {
					if (that.role == 'admin') return false;
					if (socketData.status == '0') {
						if (socketData.robotId == that.warningObj.robotId || socketData.robotId == that.robotId) {
							that.warningObj = socketData
							that.ifWarning = true
							if (that.warningDate) {
								alarmOperate({
									robotId: that.robotId,
									robotNumber: that.robotInfo.number,
									tenantInfoId: getItem('tenantInfoId'),
									status: '0'
								}).then(res => {
									if (res.code == '200') {
										that.warningFun(new Date().getTime()+10*60*1000)
									} else {
										that.$notify.error({
											title: res.message
										})
									}
								})
							}
						} else {
							that.warningObj = socketData
							that.ifWarning = true
						}
					} else if (socketData.status == '1') {
						if (socketData.robotId == that.warningObj.robotId || socketData.robotId == that.robotId) {
							if (that.ifWarningEnd) {
								that.ifWarningEnd = false
								that.clearEndInterval()
								that.warningFun(new Date().getTime()+10*60*1000)
							} else {
								if (that.warningDate) {
									that.warningFun(new Date().getTime()+10*60*1000)
								} else {
									that.ifWarning = true
								}
							}
						}
					} else if (socketData.status == '2') {
						if (socketData.robotId == that.warningObj.robotId || socketData.robotId == that.robotId) {
							if (that.ifWarning) {
								that.ifWarning = false
							} else {
								that.warningBlou = false
								that.warningDate = 0
								that.clearWarning()
							}
						}
					}
				} else if (socketData.socketType == '51') {
					const flowStatus = String(socketData.flowStatus)
					if (flowStatus === '0') {
						that.ifIndicatorLight = true
					} else if (flowStatus === '1' && that.ifIndicatorLight) {
						that.ifIndicatorLight = false
					}
				}
			},
			handleIndicatorLight(value) {
				sendIndicatorLight({
					robotNumber: this.robotInfo.number,
					indicatorLight: value
				}).then(res => {
					if (value === 2) {
						this.ifIndicatorLight = false
					}
				}).catch(() => {})
			},
			changeTap(data) {
				this.tapType = data
			},
			headOut(data) {
				this.dialogVisible = true
			},
			getOut() {
				removeToken()
				removeItem('differtime')
				removeItem('loginSuccess')
				this.dialogVisible = false
				this.$router.push({
					name: 'login'
				})
			}
		},
		watch: {
			ifWarning: {
				deep: true,
				handler(val, oldVal) {
					let that = this
					if (val) {
						that.ifWarningInterval = setTimeout(() => {
							that.ifWarning = false
						}, 30000)
					} else {
						if (that.ifWarningInterval) {
							clearTimeout(that.ifWarningInterval)
							that.ifWarningInterval = null
						}
					}
				}
			},
			warningDate: {
				deep: true,
				handler(newValue, oldValue) {
					if (!newValue && this.warningBlou) {
						let that = this
						that.ifWarningEnd = true
						that.ifWarningEndInterval = setInterval(() => {
							that.ifWarningEndNumber -= 1
							if (that.ifWarningEndNumber <= 0) {
								that.ifWarningEnd = false
								that.clearEndInterval()
							}
						},1000)
					}
				}
			},
			eventsList: {
				deep: true,
				handler(val, oldVal) {
					if (val.length == 0) {
						this.attack = false
					}
				}
			},
			ifCamera: {
				immediate: true,
				handler(newValue, oldValue) {
					if (newValue) this.ifControl = false
				}
			},
			ifControl: {
				immediate: true,
				handler(newValue, oldValue) {
					if (newValue) this.ifCamera = false
				}
			},
			ifVoice: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					if (newValue) {
						that.$refs.pnhoneAudio.play()
						setTimeout(() => {
							that.ifVoice = false
						}, 60000)
					} else {
						that.$nextTick(() => {
							if (that.$refs.pnhoneAudio) that.$refs.pnhoneAudio.pause()
						})
					}
				}
			},
			ifSIP: {
				deep: true,
				handler(val, oldVal) {
					if (!val) this.ifAgainVoice = false
				}
			},
			videoData: {
				deep: true,
				handler(newVal) {
					if (Object.keys(newVal).length > 0 && this.isPrivate && this.robotInfo.robotId) {
						console.log('M3U8数据变化，重新设置视频流');
						this.setVideoStream();
					}
				}
			},   
			robotInfo: {
						immediate: true,
						handler(newValue, oldValue) {
							let that = this
							if (newValue.robotId) {
								that.robotInfo = newValue
								// 只有在（非私有化部署&&不是香港租户）或未获取M3U8数据时才使用原有逻辑
								if ((!that.isPrivate) || Object.keys(that.videoData).length === 0) {
									console.log('------使用原有视频流逻辑------');
									if (newValue.robotType == '06') {
										// 修改：robotType=06非私有化时的初始化
										that.initRobot06Camera();
										// 单独设置主画面（云台摄像头）
										that.checkInfo = {
											name: that.languageJson.PanTiltCamera,
											src: newValue.flvPtz
										};

									}else if(newValue.tenantInfoId == "2847ec53457c42a88a87ca7d462e5dde"){//租户为公安一所时
										that.checkInfo = {
											name: languageJson.PanTiltCamera,
											src: that.robotInfo.flvPtz
										}
										that.leftInfo = {
											leftName: languageJson.ThermalImagingLight,
											leftSrc: that.robotInfo.flvThermLight,
											rightName: languageJson.ThermalImaging,
											rightSrc: that.robotInfo.flvTherm,
											rightNameTwo: languageJson.LeftCamera,//左视
											rightSrcTwo: that.robotInfo.rLeft,
											rightNameThree: languageJson.RightCamera,////右视
											rightSrcThree: that.robotInfo.rRight,
										}
									}else {
										that.checkInfo = {
											name: languageJson.PanTiltCamera,
											src: that.robotInfo.flvPtz
										}
										that.leftInfo = {
											leftName: languageJson.ThermalImagingLight,
											leftSrc: that.robotInfo.flvThermLight,
											rightName: languageJson.ThermalImaging,
											rightSrc: that.robotInfo.flvTherm
										}
									}
								} else {
									console.log('HK视频流的非私有化部署 || 私有化部署，跳过原有视频流设置');
								}
								
								that.getPtz()
							}
						}
			},
			sliderValue: {
				deep: true,
				immediate: false,
				handler(val, oldVal) {
					let that = this
					let newValControl = val
					if (that.robotInfo.robotType == '04' || that.robotInfo.robotType == '05' || that.robotInfo.robotType == '06' || that.robotInfo.robotType == '07') {
						newValControl = newValControl < 1 ? 1 : newValControl >= 10 ? 10 : newValControl
					} else {
						newValControl = newValControl < 1 ? 1 : newValControl >= 100 ? 100 : newValControl
					}
					focusesControl({
						number: that.robotInfo.number,
						tenantInfoId: getItem('tenantInfoId'),
						focal: newValControl
					}).then(res => {})
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import "./detail.less";
  /deep/ .el-input-number {
    width: 100%;
  }
</style>

<style lang="less">
/* el-dialog 覆盖样式（不能 scoped，因为 append-to-body 的 dialog 在 body 下） */
body > .el-dialog__wrapper .el-dialog {
	background: transparent !important;
	border: none !important;
	box-shadow: none !important;
	border-radius: 0 !important;
	margin: 0 auto !important;
}

body > .el-dialog__wrapper .el-dialog__header {
	display: none !important;
	padding: 0 !important;
	height: 0 !important;
}

body > .el-dialog__wrapper .el-dialog__body {
	padding: 0 !important;
}

/* HUD 风格弹框 */
body > .el-dialog__wrapper .el-dialog.hud-dialog {
	background: linear-gradient(145deg, rgba(0, 15, 50, 0.98), rgba(0, 8, 30, 0.99)) !important;
	border: 1px solid rgba(0, 240, 255, 0.2) !important;
	border-radius: 8px !important;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.5) !important;
	overflow: hidden;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		top: 0; left: 0; right: 0;
		height: 2px;
		background: linear-gradient(90deg, transparent, rgba(0, 240, 255, 0.6), rgba(0, 128, 255, 0.4), transparent);
		z-index: 2;
	}

	&::after {
		content: '';
		position: absolute;
		bottom: 0; left: 0; right: 0;
		height: 1px;
		background: linear-gradient(90deg, transparent, rgba(0, 240, 255, 0.3), transparent);
	}

	.el-dialog__body {
		padding: 2.2vw 1.5vw 1.5vw !important;
		position: relative;
	}
}

/* 透明弹框 */
body > .el-dialog__wrapper .el-dialog.transparent-dialog {
	background: transparent !important;
	border: none !important;
	box-shadow: none !important;
	border-radius: 0 !important;
}
// 台账状态开关 样式优化
.ledger-switch-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.8vw;
  padding: 0.6vw 1vw;
  .ledger-text {
    font-size: 0.9vw;
    color: #00f0ff; // 页面主题荧光蓝
    font-weight: 500;
    text-shadow: 0 0 6px rgba(0, 240, 255, 0.4); // HUD发光效果
    letter-spacing: 1px;
  }
  // 微调开关大小，更精致
  /deep/ .el-switch {
    transform: scale(0.9);
  }
  // 开关文字样式
  /deep/ .el-switch__label {
    color: #00f0ff !important;
    font-size: 0.8vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/robotDetail/index/index.vue